import React, { Component } from 'react';

import ReceptorNacionalFiscalInfoForm from './ReceptorNacionalFiscalInfoForm';
import ReceptorExtranjeroFiscalInfoForm from './ReceptorExtranjeroFiscalInfoForm';

class ReceptorFiscalInfoForm extends Component {

  state = {};

  handleOnChange = (values) => {
    this.props.onChange(values)
  }

  render() {
    const { NacionalidadR, Nacional, Extranjero } = this.props.data;

    return (
      <>
        { NacionalidadR === 'Nacional' && (
          <ReceptorNacionalFiscalInfoForm
            data={ Nacional }
            onChange={ this.handleOnChange }
          />
        )}

        { NacionalidadR === 'Extranjero' && (
          <ReceptorExtranjeroFiscalInfoForm
            data={ Extranjero }
            onChange={ this.handleOnChange }
          />
        )}
      </>
    )
  }
}

export default ReceptorFiscalInfoForm;